module.exports = __webpack_public_path__ + "img/沈尚宏.c74632c8.jpg";